export default "__VITE_ASSET__c226c175__"